import { Reveal } from "./motion";
import { MapPin } from "lucide-react";

export const FeeLocation = () => (
  <section id="fee" data-testid="fee-location" className="bg-mushroom px-5 sm:px-8 lg:px-12 py-24 sm:py-32">
    <div className="max-w-[1200px] mx-auto grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
      {/* ACCOUNTABILITY */}
      <Reveal>
        <div className="h-full bg-ink text-oat rounded-[2rem] p-8 sm:p-12">
          <span className="text-sm font-semibold uppercase tracking-[0.2em] text-sunbeam">accountability</span>
          <h3 className="mt-4 font-display font-black lowercase leading-[0.9] text-4xl sm:text-5xl" data-testid="accountability-heading">
            show up for the work
          </h3>
          <span className="mt-5 inline-block bg-sunbeam text-ink font-display font-black text-sm px-4 py-1.5 rounded-full lowercase" data-testid="fee-free-note">
            free to RSVP
          </span>
          <div className="mt-6 space-y-4 text-base sm:text-lg font-medium leading-[1.3] text-oat/85">
            <p>
              this group is about being invested — in your own work and in each other. you bring one
              real project, name what you want to move forward, and give it a focused hour alongside
              women doing the same.
            </p>
            <p>
              the accountability isn't pressure, it's a shared container. collective focus, everyone
              working in the same room, and the follow-through that comes from showing up for the work.
            </p>
            <p>
              so come meet us for free as many times as you like (once, twice...whatever you need) and
              show up as often as your life allows.
            </p>
          </div>
        </div>
      </Reveal>

      {/* WHEN & WHERE */}
      <Reveal delay={0.12}>
        <div className="h-full bg-mushroom-deep text-oat rounded-[2rem] p-8 sm:p-12">
          <span className="text-sm font-semibold uppercase tracking-[0.2em] text-oat/60">when &amp; where</span>
          <p className="mt-6 text-base sm:text-xl font-medium leading-[1.25] text-oat/90">
            in person, always. two to three times a month, september through december. most mornings fall
            on a thursday, though the day can shift with travel, school schedules, and holidays.
            you'll always know the dates ahead of time.
          </p>
          <div className="mt-8 flex items-start gap-3 border-t border-oat/20 pt-6">
            <MapPin className="w-6 h-6 shrink-0 text-sunbeam mt-0.5" strokeWidth={2.2} />
            <div className="font-display font-semibold text-xl sm:text-2xl leading-[1.05]">
              thump at the grove
              <span className="block text-base sm:text-lg font-body font-medium text-oat/70 mt-1">
                921 nw mount washington drive, bend, oregon 97703
              </span>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
